import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { InputLicensePlateComponent } from '@shared/components/input-license-plate/input-license-plate.component';
import { ENVIRONMENT_CONFIG } from '@shared/injection-token/environment-config';
import { TranslateModule } from '@ngx-translate/core';
import { GlobalRoutesPath } from '@shared/enums/global-routes-path';

@Component({
  selector: 'app-footer',
  imports: [CommonModule, RouterLink, InputLicensePlateComponent, TranslateModule],
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  readonly now = new Date();

  environmentConfig = inject(ENVIRONMENT_CONFIG);
  routesPath = this.environmentConfig.routes;
  GlobalRoutesPath = GlobalRoutesPath;
}
